import React from "react";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { BellRing, ShieldAlert, X } from "lucide-react";

export function PushPermissionModal({
  open,
  onOpenChange,
  permission,
  onRequestPermission,
}) {
  const isDenied = permission === "denied";

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-primary/10">
            {isDenied ? (
              <ShieldAlert className="h-6 w-6 text-amber-600" />
            ) : (
              <BellRing className="h-6 w-6 text-primary" />
            )}
          </div>
          <DialogTitle className="text-center text-xl">
            {isDenied ? "Notifications Blocked" : "Enable Notifications"}
          </DialogTitle>
          <DialogDescription className="text-center text-base pt-2">
            {isDenied 
              ? "Your browser is currently blocking notifications for this site. Please enable them to get calls from guests and other staff."
              : "Please enable notifications to get calls from guests and other staff members."}
          </DialogDescription>
        </DialogHeader>

        {isDenied && (
          <div className="rounded-lg bg-amber-50 p-4 text-sm text-amber-800 border border-amber-200 mt-2">
            <p className="font-medium mb-1">How to enable:</p>
            <ol className="list-decimal pl-5 space-y-1">
              <li>Click the <strong>lock icon</strong> (🔒) or settings icon in your browser's address bar.</li>
              <li>Find <strong>Notifications</strong> in the menu.</li>
              <li>Change the permission to <strong>Allow</strong>.</li>
              <li>Refresh this page.</li>
            </ol>
          </div>
        )}

        <DialogFooter className="sm:justify-center mt-4">
          {!isDenied ? (
            <Button
              type="button"
              className="w-full sm:w-auto min-w-[120px] bg-primary text-white"
              onClick={async () => {
                await onRequestPermission();
                onOpenChange(false);
              }}
            >
              Enable
            </Button>
          ) : (
            <Button
              type="button"
              variant="outline"
              className="w-full sm:w-auto min-w-[120px]"
              onClick={() => {
                window.location.reload();
              }}
            >
              I've enabled them, reload page
            </Button>
          )}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
